import { render, staticRenderFns } from "./JcdcFavorite.vue?vue&type=template&id=491640e3"
import script from "./JcdcFavorite.vue?vue&type=script&lang=ts"
export * from "./JcdcFavorite.vue?vue&type=script&lang=ts"
import style0 from "./JcdcFavorite.vue?vue&type=style&index=0&id=491640e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports